import React, { useContext } from 'react';

import DbcReportForm from './DbcReportForm';
import DbcAgentAgencyPicker from './DbcAgentAgencyPicker';
import DbcInternalAgencyPicker from './DbcInternalAgencyPicker';
import { Feature } from 'components/Feature';
import { Box, Card, CardHeader, ViewContainer } from 'components/AORedesign';
import featureFlags from 'constants/featureFlags';
import { ROUTE_REDESIGN_REPORTS } from 'constants/routes';
import agentContext from 'contexts/agent.context';

// Agents choose from their permitted agencies; internal users search every agency.
// The agent check comes first so an agent is never given access to all agencies.
const getAgencyPicker = (FeatureFlags) => {
  if (FeatureFlags?.[featureFlags.ACCESS_USER_IS_AGENT]) return DbcAgentAgencyPicker;
  if (FeatureFlags?.[featureFlags.ACCESS_USER_INTERNAL]) return DbcInternalAgencyPicker;
  return null;
};

const DbcReport = () => {
  const { FeatureFlags } = useContext(agentContext);
  const AgencyPicker = getAgencyPicker(FeatureFlags);

  return (
    <ViewContainer returnRoute={{ route: ROUTE_REDESIGN_REPORTS, text: 'Reports' }}>
      <Feature allowed={featureFlags.ACCESS_DIRECT_BILL_COMMISSION_REPORT}>
        <Box id="DbcReport" mb={2}>
          <Card>
            <CardHeader title="Direct Bill Commission Statements" />
            <Box p={2}>{AgencyPicker && <DbcReportForm AgencyPicker={AgencyPicker} />}</Box>
          </Card>
        </Box>
      </Feature>
    </ViewContainer>
  );
};

export default DbcReport;
